import { createIsland } from '@/utils/islands';
import AdvertApplicationMessagesIsland from './AdvertApplicationMessagesIsland';

export function initAdvertApplicationMessagesIsland() {
    createIsland('advert-application-messages', AdvertApplicationMessagesIsland, {
        editing: true
    });
}
